import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RolPlataforma } from '../../../core/models/novedades.models';
import { DatosPersonales } from '../../../core/models/perfil.models';
import { PerfilService } from '../../../core/services/perfil.service';
import { RoleContextService } from '../../../core/services/role-context.service';

@Component({
  selector: 'app-user-session-summary',
  imports: [CommonModule],
  templateUrl: './user-session-summary.html',
  styleUrl: './user-session-summary.css',
})
export class UserSessionSummary {
  @ViewChild('avatarInput') avatarInput?: ElementRef<HTMLInputElement>;

  rol: RolPlataforma = 'postulante';
  rolLabel = 'Postulante';
  nombreVisible = 'Usuario ANID';
  correoVisible = '';
  avatarUrl: string | null = null;
  menuAbierto = false;

  private readonly avatarStorageKey = 'anid.user.avatar';
  private datosPerfil: DatosPersonales | null = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly roleContext: RoleContextService,
    private readonly perfilService: PerfilService,
    private readonly host: ElementRef<HTMLElement>
  ) {
    this.cargarAvatarPersistido();

    this.route.queryParamMap.subscribe((params) => {
      this.rol = this.roleContext.resolveRole(params, this.rol);
      this.rolLabel = this.roleContext.getRoleLabel(this.rol);
      this.perfilService.getDatosPersonales(params.get('perfil')).subscribe((datos) => {
        this.datosPerfil = datos;
        this.correoVisible = datos.correoPrincipal.trim();
        this.actualizarNombreVisible();
      });
      this.actualizarNombreVisible();
    });
  }

  get iniciales(): string {
    if (this.avatarUrl) {
      return '';
    }

    const textoBase = this.nombreVisible.trim() || this.rolLabel.trim();
    const partes = textoBase.split(/\s+/).filter(Boolean);

    if (partes.length === 0) {
      return 'U';
    }

    return partes
      .slice(0, 2)
      .map((parte) => parte.charAt(0).toUpperCase())
      .join('');
  }

  toggleMenu(event: Event): void {
    event.stopPropagation();
    this.menuAbierto = !this.menuAbierto;
  }

  irAMiPerfil(): void {
    this.menuAbierto = false;
    void this.router.navigate(['/mi-perfil'], { queryParams: { role: this.rol } });
  }

  solicitarCambioAvatar(): void {
    this.menuAbierto = false;
    this.avatarInput?.nativeElement.click();
  }

  onAvatarSeleccionado(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const archivo = input?.files?.[0];

    if (!archivo || !archivo.type.startsWith('image/')) {
      if (input) input.value = '';
      return;
    }

    const lector = new FileReader();
    lector.onload = () => {
      const resultado = typeof lector.result === 'string' ? lector.result : '';
      if (!resultado) return;

      this.avatarUrl = resultado;
      this.guardarAvatar(resultado);
    };
    lector.readAsDataURL(archivo);

    if (input) input.value = '';
  }

  quitarAvatar(): void {
    this.avatarUrl = null;
    this.menuAbierto = false;
    if (typeof globalThis.localStorage !== 'undefined') {
      globalThis.localStorage.removeItem(this.avatarStorageKey);
    }
  }

  cerrarSesionMock(): void {
    this.menuAbierto = false;
    void this.router.navigate(['/seleccion-roles']);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.menuAbierto) return;

    const target = event.target as Node | null;
    if (target && !this.host.nativeElement.contains(target)) {
      this.menuAbierto = false;
    }
  }

  private actualizarNombreVisible(): void {
    const primerNombre = this.datosPerfil?.primerNombre?.trim() ?? '';
    const primerApellido = this.datosPerfil?.primerApellido?.trim() ?? '';
    const nombre = `${primerNombre} ${primerApellido}`.trim();

    this.nombreVisible = nombre || 'Usuario ANID';
  }

  private cargarAvatarPersistido(): void {
    if (typeof globalThis.localStorage === 'undefined') return;
    this.avatarUrl = globalThis.localStorage.getItem(this.avatarStorageKey);
  }

  private guardarAvatar(valor: string): void {
    if (typeof globalThis.localStorage === 'undefined') return;
    globalThis.localStorage.setItem(this.avatarStorageKey, valor);
  }
}
